import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// One-shot cleanup: unregister any service workers + clear all CacheStorage entries
// from older builds so existing visitors aren't stuck on a stale bundle. This app
// does NOT register a service worker — this defensive cleanup is only here to free
// users who landed on a previous build that did.
if (typeof window !== "undefined") {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }
  if ("caches" in window) {
    caches
      .keys()
      .then((keys) => keys.forEach((k) => caches.delete(k)))
      .catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
